

import {Options, Vue} from "vue-class-component";
import {ThemeTreeNode} from '@/entities/ThemeTree';
import ThemeDisplay from '@/components/ThemeDisplay.vue';
import {PropType} from 'vue';
import {Theme} from '@/entities/Theme';

@Options({
  components: {ThemeDisplay},
  props: {
    root: {
      default: undefined,
      required: true,
      type: ThemeTreeNode
    },
    themes: {
      default: [],
      required: true,
      type: Array as PropType<Array<Theme>>
    },
    entityThemes: {
      required: true,
      type: Array as PropType<Array<String>>
    }
  }
})
export default class ThemeRoot extends Vue {

  constructor(props) {
    super(props);
  }

}
